import { Button, Toast } from "@mcleod/components";
import { OrderPlanningRowAction, OrderPlanningRowActionProps, ReasonMap } from "./OrderPlanningRowAction";
import { CompanySettings, ModelRow } from "@mcleod/core";
import { YSplit } from "../../YSplit";

export class RowActionYSplit extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonYsplit;
    }

    override getButtonId(): string {
        return "buttonYsplit";
    }

    override getAdditionalProps() {
        return this.getFindNearAfterSlideoutProp();
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["move_status", "emptied", "order_id", "manifest_id", "movement_id", "manifest_hold"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];

        if ((modelRow.isNull("order_id") && modelRow.isNull("emptied")) || modelRow.isNull("movement_id")) {
            this.addReason(reasonMap, "no_order", "No order or movement found.");
            return;
        }
        if (modelRow.get("move_status") === "D") {
            this.addReason(reasonMap, "invalid_status", "Y-split is not available for delivered movements.");
        }
        if (modelRow.getBoolean("emptied", false)) {
            this.addReason(reasonMap, "emptied", "Y-split is not available for empty movements.");
        }
        if (modelRow?.getBoolean("manifest_hold", false)) {
            this.addReason(reasonMap, "manifest_hold", "Y-Split is not available for a manifest on hold.");
        }
    }

    override execute(props: OrderPlanningRowActionProps) {
        const modelRow = props.selectedRows[0]?.data as ModelRow;
        if (modelRow == null)
            return;

        const isAsset = CompanySettings.getSingleton().isAsset();
        const isBrokerage = CompanySettings.getSingleton().isBrokerage();
        this.getButton().busy = true;
        if (modelRow?.isNull("order_id") || modelRow?.isNull("movement_id")) {
            throw new Error("Cannot create Y-split without an order_id and movement_id");
        }
        YSplit.showSlideout({
            orderId: modelRow?.get("order_id"),
            manifestId: modelRow?.get("manifest_id"),
            isCompanyBoth: isAsset && isBrokerage,
            movementId: modelRow?.get("movement_id"),
            doAfterSlideOut: async (success: boolean = false) => {
                if (success) {
                    Toast.showSuccessToast("Y-split created successfully");
                }
                if (props.afterSlideout)
                    props.afterSlideout(null);
            },
        })
        this.getButton().busy = false;
    }
}
